import React from 'react';
import { Div } from '@icecreamsocial/components';

import {
	BusinessBrandForm,
	EditFormControls,
	Pagename,
} from '../../../../presentational';
import { useBusiness } from '../../../../providers/Business';

const BrandSettings = () => {
	const { business, update } = useBusiness();
	const { data, isLoading } = business;

	const initialValues = {
		logo: data?.logo,
	};

	const onSubmit = ({ logo }) => {
		update.mutate({ logo });
	};

	return (
		<Div>
			<Pagename>Brand &amp; Appearance</Pagename>
			<BusinessBrandForm
				onSubmit={onSubmit}
				renderControls={(props) => (
					<EditFormControls
						isLoading={isLoading}
						disabled={isLoading}
						{...props}
					/>
				)}
				{...initialValues}
			/>
		</Div>
	);
};

BrandSettings.displayName = 'Settings.Business.Brand';
export default BrandSettings;
